import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModalPanel from 'UIComponents/dialog/UIModalPanel';
import { H2, H6 } from 'UIComponents/elements/headings';
import UISection from 'UIComponents/section/UISection';
import { COMPONENT, EVENT, INTERACTION_TYPE, SUB_COMPONENT } from '../../../constants/tracking';
import { getIsMarketingGoal } from '../../../utils/goalConfig';
import usageTracker from '../../../utils/usageTracker';
import AdSpendTable from '../../ads-spend-table';
export default function DetailsPanel({
  goalTarget,
  handleOnClose
}) {
  const {
    goalType,
    assigneeType
  } = goalTarget;

  const handleEditInGoalSettings = () => {
    usageTracker.track(EVENT.INTERACTION, {
      interactionType: INTERACTION_TYPE.EDIT_GOAL_LINK_CLICKED,
      screen: COMPONENT.GOALS_TABLE,
      subscreen: SUB_COMPONENT.GOAL_DETAILS,
      goalType,
      assigneeType
    });
    const portalId = PortalIdParser.get();
    window.location.replace(`/goals/${portalId}/manage/edit/${goalTarget.objectId}?goalType=${goalTarget.goalType}`);
  };

  const isMarketingGoal = getIsMarketingGoal(goalTarget.goalType);
  return /*#__PURE__*/_jsxs(UIModalPanel, {
    width: 800,
    onEsc: handleOnClose,
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(H2, {
        children: goalTarget.goalName
      }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: handleOnClose
      })]
    }), /*#__PURE__*/_jsx(UIDialogBody, {
      children: isMarketingGoal && /*#__PURE__*/_jsxs(UISection, {
        className: "m-top-2",
        children: [/*#__PURE__*/_jsx(H6, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "goals-reporting-lib.detailsPanel.currentProgress"
          })
        }), /*#__PURE__*/_jsx(AdSpendTable, {
          goalTarget: goalTarget,
          adCampaigns: goalTarget.adCampaigns || []
        })]
      })
    }), goalTarget.isEditable && /*#__PURE__*/_jsx(UIDialogFooter, {
      children: /*#__PURE__*/_jsx(UIButton, {
        use: "tertiary-light",
        onClick: handleEditInGoalSettings,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "goals-reporting-lib.detailsPanel.editGoalButton"
        })
      })
    })]
  });
}